/** @format */

import { formatFloorNumber } from "../../../../utils/decimal";

export const totalPaymentColumn = [
  {
    key: "groupName",
    label: "",
    align: "left",
    isGroup: true,
    dataKey: "index",
    cellProps: {
      width: 5,
      rowCell: {
        borderRight: "1px solid #e0e0e0",
      },
    },
  },
  {
    key: "title",
    label: "",
    align: "left",
    cellProps: {
      minWidth: 20,
      width: "9%",
    },
  },
  {
    key: "partition",
    label: "仕切数",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "9%",
    },
    render: item => {
      return typeof item.partition === "number"
        ? new Intl.NumberFormat().format(item?.partition.toFixed(0))
        : item.partition;
    },
  },
  {
    key: "partitionAmount",
    label: "仕切金額",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "9%",
    },
    render: item => {
      return typeof item.partitionAmount === "number"
        ? new Intl.NumberFormat().format(item?.partitionAmount.toFixed(0))
        : item.partitionAmount;
    },
  },
  {
    key: "consumptionTax",
    label: "消費税",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "9%",
    },
    render: item => {
      return typeof item.consumptionTax === "number"
        ? new Intl.NumberFormat().format(item?.consumptionTax.toFixed(0))
        : item.consumptionTax;
    },
  },
  {
    key: "taxInclude",
    label: "税込仕切額",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "9%",
    },
    render: item => {
      return typeof item.taxInclude === "number"
        ? new Intl.NumberFormat().format(item?.taxInclude.toFixed(0))
        : item.taxInclude;
    },
  },
  {
    key: "commission",
    label: "手数料",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "9%",
    },
    render: item => {
      return typeof item.commission === "number"
        ? new Intl.NumberFormat().format(item?.commission.toFixed(0))
        : item.commission;
    },
  },
  {
    key: "fare",
    label: "運賃",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "9%",
    },
    render: item => {
      return typeof item.fare === "number"
        ? new Intl.NumberFormat().format(item?.fare.toFixed(0))
        : item.fare;
    },
  },
  {
    key: "other",
    label: "その他",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "9%",
    },
    render: item => {
      return typeof item.other === "number"
        ? new Intl.NumberFormat().format(item?.other.toFixed(0))
        : item.other;
    },
  },
  {
    key: "totalFeeIncludingTax",
    label: "税込控除合計",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "9%",
    },
    render: item => {
      return typeof item.totalFeeIncludingTax === "number"
        ? new Intl.NumberFormat().format(item?.totalFeeIncludingTax.toFixed(0))
        : item.totalFeeIncludingTax;
    },
  },
  {
    key: "balanceAmount",
    label: "差引仕切額",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "9%",
    },
    render: item => {
      return typeof item.balanceAmount === "number"
        ? new Intl.NumberFormat().format(item?.balanceAmount.toFixed(0))
        : item.balanceAmount;
    },
  },
  {
    key: "payment",
    label: "支払額",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "9%",
    },
    render: item => {
      return typeof item.payment === "number"
        ? new Intl.NumberFormat().format(item?.payment.toFixed(0))
        : item.payment;
    },
  },
  {
    key: "balance",
    label: "残高",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "9%",
    },
    render: item => {
      return typeof item.balance === "number"
        ? new Intl.NumberFormat().format(item?.balance.toFixed(0))
        : item.balance;
    },
  },
];

const getConsignor = consignor => {
  if (!consignor) return "";
  const temp = "000000" + consignor.toString();
  return (
    temp.substring(temp.length - 6, temp.length - 4) +
    "-" +
    temp.substring(temp.length - 4, temp.length)
  );
};

export const accountPaymentColumn = [
  {
    key: "consignor",
    label: "荷主",
    align: "left",
    isGroup: true,
    dataKey: "index",
    cellProps: {
      minWidth: 20,
      width: "5.64%",
      rowCell: {
        verticalAlign: "top",
        paddingTop: "20px !important",
      },
    },
    render: ({ consignor }) =>
      getConsignor(consignor),
  },
  {
    key: "invoiceNumber",
    label: "送状番号",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "6.40%",
    },
  },
  {
    key: "productName",
    label: "品名",
    align: "left",
    cellProps: {
      minWidth: 20,
      width: "12%",
    },
  },
  {
    key: "partition",
    label: "仕切数",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "4.92%",
    },
    render: item => {
      return typeof item.partition === "number"
        ? new Intl.NumberFormat().format(item?.partition.toFixed(0))
        : item.partition;
    },
  },
  {
    key: "partitionAmount",
    label: "仕切金額",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "7.14%",
    },
    render: item => {
      return typeof item.partitionAmount === "number"
        ? new Intl.NumberFormat().format(item?.partitionAmount.toFixed(0))
        : item.partitionAmount;
    },
  },
  {
    key: "consumptionTax",
    label: "消費税",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "5.64%",
    },
    render: item => {
      return typeof item.consumptionTax === "number"
        ? new Intl.NumberFormat().format(item?.consumptionTax.toFixed(0))
        : item.consumptionTax;
    },
  },
  {
    key: "taxInclude",
    label: "税込仕切額",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "7.14%",
    },
    render: item => {
      return typeof item.taxInclude === "number"
        ? new Intl.NumberFormat().format(item?.taxInclude.toFixed(0))
        : item.taxInclude;
    },
  },
  {
    key: "commission",
    label: "手数料",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "5.64%",
    },
    render: item => {
      return typeof item.commission === "number"
        ? new Intl.NumberFormat().format(item?.commission.toFixed(0))
        : item.commission;
    },
  },
  {
    key: "fare",
    label: "運賃",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "5.64%",
    },
    render: item => {
      return typeof item.fare === "number"
        ? new Intl.NumberFormat().format(item?.fare.toFixed(0))
        : item.fare;
    },
  },
  {
    key: "other",
    label: "その他",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "5.64%",
    },
    render: item => {
      return typeof item.other === "number"
        ? new Intl.NumberFormat().format(item?.other.toFixed(0))
        : item.other;
    },
  },
  {
    key: "other",
    label: "税込控除計",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "7.14%",
    },
    render: item => {
      return typeof item.totalFeeIncludingTax === "number"
        ? new Intl.NumberFormat().format(item?.totalFeeIncludingTax.toFixed(0))
        : item.totalFeeIncludingTax;
    },
  },
  {
    key: "balanceAmount",
    label: "差引仕切額",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "7.14%",
    },
    render: item => {
      return typeof item.balanceAmount === "number"
        ? new Intl.NumberFormat().format(item?.balanceAmount.toFixed(0))
        : item.balanceAmount;
    },
  },
  {
    key: "payment",
    label: "支払額",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "5.64%",
    },
    render: ({ payment, isPaymentRow }) => {
      return isPaymentRow === true
        ? typeof payment === "number"
          ? new Intl.NumberFormat().format(payment.toFixed(0))
          : payment
        : null;
    },
  },
  {
    key: "balance",
    label: "残高",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "7.14%",
    },
    render: item => {
      return typeof item.balance === "number"
        ? formatFloorNumber(item.balance)
        : item.balance;
    },
  },
  {
    key: "finalPayment",
    label: "最終支払",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "7.14%",
    },
  },
];

export const accountPaymentMonthlyColumn = [
  {
    key: "consignor",
    label: "荷主",
    align: "left",
    isGroup: true,
    dataKey: "index",
    cellProps: {
      minWidth: 20,
      width: "5.64%",
      rowCell: {
        verticalAlign: "top",
        paddingTop: "20px !important",
      },
    },
    render: ({ consignor }) =>
      getConsignor(consignor),
  },
  {
    key: "commodityOwnerName",
    label: "荷主名",
    align: "left",
    cellProps: {
      minWidth: 20,
      width: "18.40%",
    },
  },
  {
    key: "partition",
    label: "仕切数",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "4.92%",
    },
    render: item => {
      return typeof item.partition === "number"
        ? new Intl.NumberFormat().format(item?.partition.toFixed(0))
        : item.partition;
    },
  },
  {
    key: "partitionAmount",
    label: "仕切金額",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "7.14%",
    },
    render: item => {
      return typeof item.partitionAmount === "number"
        ? new Intl.NumberFormat().format(item?.partitionAmount.toFixed(0))
        : item.partitionAmount;
    },
  },
  {
    key: "consumptionTax",
    label: "消費税",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "5.64%",
    },
    render: item => {
      return typeof item.consumptionTax === "number"
        ? new Intl.NumberFormat().format(item?.consumptionTax.toFixed(0))
        : item.consumptionTax;
    },
  },
  {
    key: "taxInclude",
    label: "税込仕切額",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "7.14%",
    },
    render: item => {
      return typeof item.taxInclude === "number"
        ? new Intl.NumberFormat().format(item?.taxInclude.toFixed(0))
        : item.taxInclude;
    },
  },
  {
    key: "commission",
    label: "手数料",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "5.64%",
    },
    render: item => {
      return typeof item.commission === "number"
        ? new Intl.NumberFormat().format(item?.commission.toFixed(0))
        : item.commission;
    },
  },
  {
    key: "fare",
    label: "運賃",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "5.64%",
    },
    render: item => {
      return typeof item.fare === "number"
        ? new Intl.NumberFormat().format(item?.fare.toFixed(0))
        : item.fare;
    },
  },
  {
    key: "other",
    label: "その他",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "5.64%",
    },
    render: item => {
      return typeof item.other === "number"
        ? new Intl.NumberFormat().format(item?.other.toFixed(0))
        : item.other;
    },
  },
  {
    key: "other",
    label: "税込控除計",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "7.14%",
    },
    render: item => {
      return typeof item.totalFeeIncludingTax === "number"
        ? new Intl.NumberFormat().format(item?.totalFeeIncludingTax.toFixed(0))
        : item.totalFeeIncludingTax;
    },
  },
  {
    key: "balanceAmount",
    label: "差引仕切額",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "7.14%",
    },
    render: item => {
      return typeof item.balanceAmount === "number"
        ? new Intl.NumberFormat().format(item?.balanceAmount.toFixed(0))
        : item.balanceAmount;
    },
  },
  {
    key: "payment",
    label: "支払額",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "5.64%",
    },
    render: ({ payment, isPaymentRow }) => {
      return isPaymentRow === true
        ? typeof payment === "number"
          ? new Intl.NumberFormat().format(payment.toFixed(0))
          : payment
        : null;
    },
  },
  {
    key: "balance",
    label: "残高",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "7.14%",
    },
    render: item => {
      return typeof item.balance === "number"
        ? formatFloorNumber(item.balance)
        : item.balance;
    },
  },
  {
    key: "finalPayment",
    label: "最終支払",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "7.14%",
    },
  },
];